// extracted by mini-css-extract-plugin
export default {"form":"activate-employee_form__kUfVv"};